import Link from "next/link";
import { useRouter } from "next/router";

import { cn } from "../../../lib/utils";
import { NavigationMenuLink, navigationMenuTriggerStyle } from "../../ui/navigation-menu";

export const SecondaryNavLink = ({
  path,
  label,
  className,
}: {
  path: string;
  label: string;
  className?: string;
}) => {
  const { asPath } = useRouter();
  return (
    <NavigationMenuLink asChild>
      <Link
        href={path}
        className={cn(
          navigationMenuTriggerStyle(),
          "mt-1 text-xs opacity-70 hover:opacity-100",
          className,
          asPath === path && "decoration-primary underline underline-offset-4 opacity-40",
        )}
      >
        {label}
      </Link>
    </NavigationMenuLink>
  );
};
SecondaryNavLink.displayName = "SecondaryNavLink";
